import {
  CButton,
  CCol,
  CContainer,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
  CRow,
} from "@coreui/react";
import { useState } from "react";
import { Spinner } from "react-bootstrap";
import { deleteItem } from "../../api/generics";
import { SUCCESS } from "../../utils/constants/tags";
import { errorAlert } from "../utils/messages";
import Subcompany from "../../models/subcompany";

interface SubcompanyDeleteModalProps {
  show: boolean;
  subcompany?: Subcompany;
  onCancel: () => void | Promise<void>;
  onSuccess: () => void | Promise<void>;
}

const SubcompanyDeleteModal: React.FC<SubcompanyDeleteModalProps> = ({
  show,
  subcompany,
  onCancel,
  onSuccess,
}) => {
  const [submitting, setSubmitting] = useState(false);

  const message = subcompany
    ? `Está seguro de que quiere eliminar la sub organización ${subcompany.name}`
    : "";

  const onDeleteClick = async () => {
    if (subcompany !== undefined) {
      setSubmitting(true);
      const typeStatus = await deleteItem<Subcompany>(
        `/subcompanies/${subcompany.id}/`,
        subcompany
      );

      if (typeStatus.status !== SUCCESS) {
        let message = "Ha ocurrido un error!!";
        if (typeStatus.detail !== undefined) {
          message = typeStatus.detail;
        }
        errorAlert(message);
      } else {
        onSuccess();
      }

      setSubmitting(false);
    }
  };

  return (
    <CModal show={show} className="modal-danger" onClosed={onCancel} size="xl">
      <CModalHeader closeButton>
        <CModalTitle>Eliminar</CModalTitle>
      </CModalHeader>
      <CModalBody>
        <CContainer fluid>
          <CRow>
            <CCol sm="12">
              <h2>{message}</h2>
            </CCol>
          </CRow>
        </CContainer>
      </CModalBody>
      <CModalFooter>
        <CButton disabled={submitting} onClick={onDeleteClick} color="danger">
          {submitting ? (
            <Spinner
              animation="grow"
              style={{
                height: "17px",
                width: "17px",
                marginTop: "auto",
                marginBottom: "auto",
                marginRight: "10px",
              }}
            />
          ) : (
            <></>
          )}
          {submitting ? "Eliminando..." : "Eliminar"}
        </CButton>
      </CModalFooter>
    </CModal>
  );
};

export default SubcompanyDeleteModal;
